import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'
import { TENANT_CONFIG } from "@/store/mutation-types";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

// store.dispatch('ThemeRouter').then(() => {
//   // 动态添加主题路由表
//   let tenantConfig = Vue.ls.get(TENANT_CONFIG);
//   let themeRouterMap = require(`@/theme/${tenantConfig.theme}/router.config.js`)

//   console.log(themeRouterMap);
//   router.addRoutes(themeRouterMap.default)
// })

let flag = true

router.beforeEach((to, from, next) => {
  if (flag) {
    let tenantConfig = Vue.ls.get(TENANT_CONFIG);
    let themeRouterMap = require(`@/theme/${tenantConfig.theme}/router.config.js`)
    store.dispatch('ThemeRouter', themeRouterMap).then(() => {
      // 动态添加主题路由表
      router.addRoutes(store.getters.addRouters)
      store.dispatch('clearThemeRouter')
      const redirect = decodeURIComponent(from.query.redirect || to.path)
      if (to.path === redirect) {
        // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        next({ ...to, replace: true })
      } else {
        // 跳转到目的路由
        next({ path: redirect })
      }
    })
    flag = false
  } else {
    next()
  }
})

export default router